module.exports = __webpack_public_path__ + "img/map2_w.b602df14.svg";